export default __webpack_public_path__ + "static/media/note-size_h1.43996d41.svg";